<template>
  <footer class="bg-gray-900 text-gray-300 py-8 mt-8">
    <div
      class="container mx-auto px-4 text-xs grid grid-cols-1 md:grid-cols-4 gap-8"
    >
      <div>
        <div class="font-bold text-white mb-2">Navigation</div>
        <ul class="space-y-1">
          <li v-for="item in footerLinks.navigation" :key="item.label">
            <a :href="item.href" class="hover:underline">{{ item.label }}</a>
          </li>
        </ul>
      </div>
      <div>
        <div class="font-bold text-white mb-2">Bonus & Codes</div>
        <ul class="space-y-1">
          <li v-for="item in footerLinks.bonus" :key="item.label">
            <a :href="item.href" class="hover:underline">{{ item.label }}</a>
          </li>
        </ul>
      </div>
      <div>
        <div class="font-bold text-white mb-2">Paris & Conseils</div>
        <ul class="space-y-1">
          <li v-for="item in footerLinks.paris" :key="item.label">
            <a :href="item.href" class="hover:underline">{{ item.label }}</a>
          </li>
        </ul>
      </div>
      <div>
        <div class="font-bold text-white mb-2">Autres</div>
        <ul class="space-y-1">
          <li v-for="item in footerLinks.autres" :key="item.label">
            <a :href="item.href" class="hover:underline">{{ item.label }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="container mx-auto px-4 text-center text-xs mt-6 text-gray-500">
      Ces contenus sont à titre informatif uniquement. Jouez responsable. 18+<br />
      © Tous Droits Réservés 2025
    </div>
  </footer>
</template>

<script setup>
const footerLinks = {
  navigation: [{ label: 'Accueil', href: '/' }],
  bonus: [
    { label: 'Tous les bonus', href: '/bonus/index' },
    { label: 'Top 5 des meilleurs bonus', href: '/bonus/top-bonus' },
    {
      label: "Bonus Côte d'Ivoire",
      href: '/bonus/bonus-par-pays/cote-divoire',
    },
    { label: 'Bonus Sénégal', href: '/bonus/bonus-par-pays/senegal' },
    { label: 'Conditions bonus', href: '/bonus/conditions-bonus' },
    { label: 'Codes promo valides', href: '/codes-promo/index' },
    { label: 'Code Bet365', href: '/codes-promo/bet365' },
    { label: 'Code 1xBet', href: '/codes-promo/1xbet' },
    { label: 'Code Melbet', href: '/codes-promo/melbet' },
  ],
  paris: [
    { label: 'Pronostics', href: '/pronostics/index' },
    { label: "Aujourd'hui", href: '/pronostics/aujourd-hui' },
    { label: 'Demain', href: '/pronostics/demain' },
    { label: 'Ligue 1', href: '/pronostics/football/ligue-1' },
    { label: 'Premier League', href: '/pronostics/football/premier-league' },
    { label: 'Astuces & stratégies', href: '/astuces/index' },
    { label: 'Types de paris 1N2', href: '/astuces/types-de-paris/1n2' },
    { label: 'Gestion bankroll', href: '/astuces/techniques/gestion-bankroll' },
    { label: 'Erreurs à éviter', href: '/astuces/erreurs-a-eviter' },
  ],
  autres: [
    { label: 'Bookmakers', href: '/bookmakers/index' },
    { label: '1xBet', href: '/bookmakers/1xbet' },
    { label: 'Bet365', href: '/bookmakers/bet365' },
    { label: 'Comparateurs', href: '/comparateurs/index' },
    {
      label: 'Comparateur cotes',
      href: '/comparateurs/comparateur-cotes/football',
    },
    { label: 'Comparateur bonus', href: '/comparateurs/comparateur-bonus' },
    { label: 'Paiements', href: '/paiements/index' },
    { label: 'Mobile Money', href: '/paiements/mobile-money' },
    { label: 'Crypto', href: '/paiements/crypto' },
    { label: 'Actualités', href: '/actualites/index' },
    { label: 'Transferts', href: '/actualites/transferts' },
    { label: 'Analyses matches', href: '/actualites/analyses-matches' },
    { label: 'Débuter dans les paris', href: '/guides/debuter-paris' },
    { label: 'Lexique', href: '/guides/lexique' },
    { label: 'Jeu responsable', href: '/guides/jeu-responsable' },
    { label: 'À propos', href: '/apropos/index' },
    { label: 'Business model', href: '/apropos/business-model' },
    { label: 'Contact', href: '/contact/index' },
    { label: 'Mentions légales', href: '/legal/mentions-legales' },
    { label: 'Confidentialité', href: '/legal/politique-confidentialite' },
    { label: 'CGU', href: '/legal/cgu' },
  ],
}
</script>

<style scoped></style>
